export default __webpack_public_path__ + "static/media/HyperTube.256.0b32e1de.png";